import axios from "axios";
import utils from "@/services/utils";

export default {
  async search(searchOptions) {
    try {
      const response = await axios.get("/sighting/groups", {
        params: {
          ...utils.buildApiSearchQuery(searchOptions, "email", false),
          start_date: searchOptions.startDate,
          end_date: searchOptions.endDate,
          incident_nature: searchOptions.incidentNature.join(";"),
          species: searchOptions.species.join(";"),
          archived: searchOptions?.archived ?? false,
        },
      });
      const data = response.data;
      return { message: "Got sightings", data: data.items, total: data.total };
    } catch (e) {
      return { message: "No sightings found", data: [], total: 0 };
    }
  },
  async create(sightingsToCreate) {
    return await axios.post(`/sighting/`, sightingsToCreate);
  },
  async group(sightingNumber) {
    return await axios.get(`/sighting/group/${sightingNumber}`);
  },
  async imagesForSighting(sightingNumber) {
    try {
      const response = await axios.get("/sighting/images", {
        params: { sighting_number: sightingNumber, limit: -1 },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async allSightings() {
    try {
      const response = await axios.get("/sighting/", {
        params: { limit: -1 },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async update(sightingsToUpdate) {
    return await axios.put(`/sighting/`, sightingsToUpdate);
  },
  async delete(sightingNumber) {
    return await axios.delete(`/sighting/${sightingNumber}`);
  },
  async archive(sightingNumber) {
    return await axios.put(`/sighting/${sightingNumber}/archive`);
  },
  async restore(sightingNumber) {
    return await axios.put(`/sighting/${sightingNumber}/restore`);
  },
  async exportCsv(sightingNumbers) {
    const response = await axios.post(
      "/sighting/sighting_data_export",
      { sightingNumbers: sightingNumbers },
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sightings_export.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
  async publicCreate(sightingToCreate) {
    return await axios.post(`/sighting/public/`, sightingToCreate);
  },
  async sendEmail(sightingId, emailRequest) {
    return await axios.post(`/sighting/email/${sightingId}`, emailRequest)
  },
  async previewEmail(sightingId, emailRequest) {
    return await axios.post(`/sighting/email/preview/${sightingId}`, emailRequest)
  },
  uploadSightingsFile(file) {
    let formData = new FormData();
    formData.append("sightings_file", file);
    return axios.put(`/upload/sightings_upload`, formData);
  },
};
